import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FC } from 'react';

type PauseProps = {
    className?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Pause: FC<PauseProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'pause'}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            viewBox="0 0 250 250"
        >
            <path d="M125 0C56 0 0 56 0 125s56 125 125 125 125-56 125-125S194 0 125 0zm0 240c-63.5 0-115-51.5-115-115S61.5 10 125 10s115 51.5 115 115-51.5 115-115 115z" />
            <rect x="85.5" y="80" width="22" height="90" />
            <rect x="142.5" y="80" width="22" height="90" />
        </svg>
    );
};

export default Pause;
